import { IConsumer, IEvent, createConsumer, createSubscriber } from '@cian/events-log';
import { useEffect, useState } from 'react';

import { useApplicationContext } from '../../../utils/applicationContext';

const MICROFRONTEND_NAME = 'moderation-complain-frontend';
let consumer: IConsumer;

type UseModerationComplaintProps = {
  onCloseModal(): void;
  getComplaints(): void;
};

export const useModerationComplaint = ({ onCloseModal, getComplaints }: UseModerationComplaintProps) => {
  const { microfrontendsRegistry } = useApplicationContext();

  const registryMicrofront = !!microfrontendsRegistry.microfrontend(MICROFRONTEND_NAME);
  const [isLoading, setIsLoading] = useState(false);

  const effectHandler = (): void => {
    consumer ??= createConsumer({ topic: 'complaintsModal' });

    const complaintsSubscriber = createSubscriber((event: IEvent<unknown>) => {
      if (event.type === 'popup_close') {
        consumer.unsubscribe(complaintsSubscriber);
        onCloseModal();
      }
    });

    consumer.subscribe(complaintsSubscriber);
  };

  useEffect(() => {
    if (!registryMicrofront) {
      getComplaints();
    } else {
      setIsLoading(false);
    }
    effectHandler();
  }, [registryMicrofront]);

  const refetch = () => {
    setIsLoading(true);
    getComplaints();
  };

  return {
    isLoading,
    refetch,
  };
};
